import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=2135496c&scoped=true"
import script from "./LogDetail.vue?vue&type=script&lang=ts"
export * from "./LogDetail.vue?vue&type=script&lang=ts"
import style0 from "./LogDetail.vue?vue&type=style&index=0&id=2135496c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135496c",
  null
  
)

export default component.exports